module.exports = __webpack_public_path__ + "img/4-l@2x.49460556.jpg";